import { useState, useEffect, useCallback } from "react";

import api from "../../services/api";

// Compatibilidade: antes o módulo Tarefas (key "tasks") vivia DENTRO de
// "Quadros / Kanban" (key "kanban"). Quem já contratou Kanban no passado
// continua tendo Tarefas sem pagar a mais — não quebra cliente antigo.
// Essa mesma regra existe no backend (CompanyAccessService).
const ALIASES = {
	kanban: ["kanban", "tasks"],
	tasks: ["tasks", "kanban"],
};

const chavesComAlias = (chave) => ALIASES[chave] || [chave];

// O que a empresa logada contratou. Serve para esconder do menu o que ela
// não pode usar — sem isso a pessoa só descobre ao clicar e tomar um 403.
const useModules = () => {
	const [modules, setModules] = useState([]);
	const [assinatura, setAssinatura] = useState(null);
	const [carregando, setCarregando] = useState(true);

	const carregar = useCallback(async () => {
		try {
			const { data } = await api.get("/subscriptions/mine");
			let keys = (data.modules || []).map((m) => m.key);
			// aplica compatibilidade kanban/tasks antes de salvar:
			// se tiver um, adiciona o outro (evita checagem duplicada em todo lugar).
			const setKeys = new Set(keys);
			setKeys.forEach(k => {
				if (ALIASES[k]) ALIASES[k].forEach(a => setKeys.add(a));
			});
			setModules([...setKeys]);
			setAssinatura(data);
		} catch (err) {
			// Falha aqui não pode esconder o sistema inteiro: sem resposta,
			// libera o menu e deixa o backend barrar quem não tiver acesso.
			setModules(null);
		}
		setCarregando(false);
	}, []);

	useEffect(() => {
		carregar();
	}, [carregar]);

	// modules === null significa "não consegui saber" — não esconde nada.
	const temModulo = useCallback(
		(chave) => modules === null || chavesComAlias(chave).some(k => modules.includes(k)),
		[modules]
	);

	return { modules, assinatura, temModulo, carregando, recarregar: carregar };
};

export default useModules;
